// Единый вид просроченной даты. До этого подсветка была в шести местах с тремя
// разными оформлениями (красный текст с ⚠ / инлайн-стиль / только цвет).
import type { CSSProperties, ReactElement } from 'react';

import { formatDateTime, isPastDue } from '../format/index.js';
import { useTranslation } from '@govard/i18n-core/react';

const OVERDUE_ROW_BG = 'var(--ant-color-error-bg)';

interface OverdueDateProps {
  iso?: string | null | undefined;
  /** Уже закрытая работа просроченной не считается (выполненная задача, отменённая встреча). */
  closed?: boolean;
  /** Подсказка при наведении, если срок прошёл. */
  title?: string;
  /** Плотная вёрстка (шапки) — только цвет, без значка. */
  compact?: boolean;
}

/** Дата со стандартной подсветкой просрочки. */
export function OverdueDate({
  iso,
  closed = false,
  title,
  compact = false,
}: OverdueDateProps): ReactElement {
  const { t } = useTranslation();
  const visibleTitle = title ?? t('crm.shared.overdue');
  const overdue = !closed && isPastDue(iso);
  if (!overdue) {
    return <span className="text-gray-700">{formatDateTime(iso)}</span>;
  }
  return (
    <span
      className="font-medium"
      style={{ color: 'var(--ant-color-error-text)' }}
      title={visibleTitle}
    >
      {formatDateTime(iso)}
      {compact ? '' : ' ⚠'}
    </span>
  );
}

/** Пропсы строки таблицы: подсветка фона у просроченных записей. */
export function overdueRowStyle(overdue: boolean): { style?: CSSProperties } {
  return overdue ? { style: { background: OVERDUE_ROW_BG } } : {};
}
